import React from 'react'

const Textarea = (props) => <textarea {...props} />

export default Textarea
